import React, { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  section?: string;
  tag?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = "DiMaria Bet | En İyi Casino ve Bahis Deneyimi",
  description = "DiMaria Bet - En popüler slot oyunları, canlı casino ve spor bahisleri. Büyük kazançlar ve özel promosyonlar sizi bekliyor. Güvenilir ve hızlı bahis deneyimi.",
  keywords = "DiMaria Bet, casino, bahis, slot oyunları, canlı casino, spor bahisleri, rulet, blackjack, poker, free spin, jackpot, bonus, promosyon",
  image = "/og-image.png",
  url = "https://dimariabet.com",
  type = "website",
  author = "DiMaria Bet",
  publishedTime,
  modifiedTime,
  section,
  tag
}) => {
  const fullUrl = url.startsWith('http') ? url : `https://dimariabet.com${url}`;
  const fullImageUrl = image.startsWith('http') ? image : `https://dimariabet.com${image}`;

  useEffect(() => {
    // Title güncelleme
    document.title = title;
    
    // Meta tag'leri güncelleme
    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updatePropertyTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // Primary Meta Tags
    updateMetaTag('title', title);
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', author);
    updateMetaTag('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    updateMetaTag('language', 'Turkish');
    updateMetaTag('revisit-after', '1 days');
    updateMetaTag('distribution', 'global');
    updateMetaTag('rating', 'general');

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = fullUrl;

    // Open Graph / Facebook
    updatePropertyTag('og:type', type);
    updatePropertyTag('og:url', fullUrl);
    updatePropertyTag('og:title', title);
    updatePropertyTag('og:description', description);
    updatePropertyTag('og:image', fullImageUrl);
    updatePropertyTag('og:image:width', '1200');
    updatePropertyTag('og:image:height', '630');
    updatePropertyTag('og:site_name', 'DiMaria Bet');
    updatePropertyTag('og:locale', 'tr_TR');

    // Twitter
    updatePropertyTag('twitter:card', 'summary_large_image');
    updatePropertyTag('twitter:url', fullUrl);
    updatePropertyTag('twitter:title', title);
    updatePropertyTag('twitter:description', description);
    updatePropertyTag('twitter:image', fullImageUrl);

    // Article specific meta tags
    if (type === 'article') {
      if (publishedTime) updatePropertyTag('article:published_time', publishedTime);
      if (modifiedTime) updatePropertyTag('article:modified_time', modifiedTime);
      if (section) updatePropertyTag('article:section', section);
      if (tag) updatePropertyTag('article:tag', tag);
      updatePropertyTag('article:author', author);
    }

    // Structured Data / JSON-LD
    const structuredData = {
      "@context": "https://schema.org",
      "@type": type === 'article' ? 'Article' : 'WebPage',
      "name": title,
      "description": description,
      "url": fullUrl,
      "image": fullImageUrl,
      "author": {
        "@type": "Organization",
        "name": author
      },
      "publisher": {
        "@type": "Organization",
        "name": "DiMaria Bet",
        "logo": {
          "@type": "ImageObject",
          "url": "https://dimariabet.com/logo.png"
        }
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": fullUrl
      },
      "datePublished": publishedTime || new Date().toISOString(),
      "dateModified": modifiedTime || new Date().toISOString(),
      "inLanguage": "tr-TR",
      "isPartOf": {
        "@type": "WebSite",
        "name": "DiMaria Bet",
        "url": "https://dimariabet.com"
      }
    };

    // Mevcut structured data script'ini kaldır
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Yeni structured data script'i ekle
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

  }, [title, description, keywords, fullUrl, fullImageUrl, type, author, publishedTime, modifiedTime, section, tag]);

  return null; // Bu bileşen sadece SEO için kullanılır, render etmez
};

export default SEO; 